import { Link } from "gatsby"
import React from "react"
import BgWorkTravelImg from "../../../images/bg-ayampe-sunrise.png"

const Hero = () => {
  return (
    <section
      className="bg-cover bg-no-repeat bg-center py-48"
      style={{ backgroundImage: `url(${BgWorkTravelImg})` }}
    >
      <div className="container mx-auto px-6 text-center text-white w-full lg:w-1/2">
        <h1 className="text-6xl pb-12 font-semibold">Work & Travel</h1>
        <h3 className="text-4xl text-tertiary pb-8 font-medium">
          Travel with us, develop your genius, and live unique experiences!
        </h3>
        <h5 className="text-2xl font-light pb-8">
          We want our Avalithers to live unique experiences, where they can
          enjoy and enhance their development.
        </h5>
        <p className="text-3xl font-semibold pb-12">Are you ready?</p>
        <Link
          to="/contact"
          className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn"
        >
          Contact us
        </Link>
      </div>
    </section>
  )
}

export default Hero
